import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '../core/settings/settings.service';

@Pipe({
  name: "settingName"
})
@Injectable({
  providedIn: 'root'
})
export class SettingNamePipe implements PipeTransform {
  constructor(private settingsService: SettingsService) {
  }

  transform(settingName: string): string {
    return this.settingsService.getSettingType(settingName).label;
  }
}
